import { buildCoverageSection, buildSubscriptionDescriptionSection } from "../SubscriptionInfoDialog/buildCoverageSection";
/**
 * 구독은 해지 시점까지 유효해 사용 기간이 상품 속성이 아니다.
 * plan 응답에 period 가 없는 것도 같은 이유이며, 시안(이용권 정보 다이얼로그)이 고정 문구를 쓴다.
 */ export const SUBSCRIPTION_PERIOD_TEXT = "구독 해지시까지 사용 가능";
/** 사용 기간 한 행. 구독은 서버값으로 계산할 게 없어 상수 문구다 */ const buildSummarySection = ()=>({
        id: "summary",
        layout: "inline",
        rows: [
            {
                label: "사용 기간",
                value: SUBSCRIPTION_PERIOD_TEXT
            }
        ]
    });
/**
 * 월구독 이용권 정보 다이얼로그의 본문 섹션 파생.
 *
 * 기존 getPassInfoSections 와 같은 규약을 따른다 — 렌더 트리와 무관한 순수 함수이고,
 * null 을 반환한 빌더는 제거돼 '섹션의 유무' 자체가 결과 배열에 표현된다.
 * 그래서 PassInfoDialogBody 를 그대로 재사용할 수 있다.
 *
 * getPassInfoSections 를 쓰지 못하는 이유는 입력 타입이 다르기 때문이다. 그쪽은
 * UseTicketProductInfo(category·deductionMethod·period·가격 등)를 요구하는데
 * benefits.items 에는 8개 필드만 있다. 시안이 엑스퍼트 사용범위·가격·총 횟수 행을
 * 요구하지 않아 없는 필드가 문제되지 않는다.
 *
 * SUBSCRIPTION_PERIOD_TEXT 요약 1행이 이 다이얼로그만의 몫이고, 나머지 2섹션은
 * 구독 관리 상세 다이얼로그(getSubscriptionInfoSections)와 공용 빌더를 공유한다.
 *
 * grantCount 는 의도적으로 쓰지 않는다 — 월 구독은 매달 지급이라 '총 사용 가능 횟수'가
 * 성립하지 않고, 시안에도 해당 행이 없다.
 */ export const getSubscriptionBenefitSections = (item)=>[
        buildSummarySection(),
        // 사용범위·상세정보는 구독 관리 상세 다이얼로그와 같은 표라 공용 빌더를 쓴다.
        // plan 응답은 단수형 키에 문자열, 구독 상세 응답은 복수형 키에 배열이라 여기서 키를 맞춰준다
        buildCoverageSection({
            subjects: item.subject,
            courses: item.curriculum,
            authors: item.authors,
            publishers: item.publishers,
            productTypes: item.productType
        }),
        buildSubscriptionDescriptionSection(item.description)
    ].filter((section)=>section !== null);
